
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import BasicInfoSection from "./sections/BasicInfoSection";
import DescriptionSection from "./sections/DescriptionSection";
import PricingSection from "./sections/PricingSection";
import PublishSection from "./sections/PublishSection";
import VersionLicenseSection from "./sections/VersionLicenseSection";

const AgentFormContent: React.FC = () => {
  return (
    <Card>
      <CardContent className="pt-6 space-y-6">
        <BasicInfoSection />
        
        <Separator className="my-6" />
        
        <h3 className="text-lg font-medium">Details</h3>
        <DescriptionSection />
        
        <Separator className="my-6" />
        
        <PricingSection />
        
        <Separator className="my-6" />
        
        <h3 className="text-lg font-medium mb-4">Technical Information</h3>
        <VersionLicenseSection />
        
        <div className="mt-6">
          <PublishSection />
        </div>
      </CardContent>
    </Card>
  );
};

export default AgentFormContent;
